import React, {useContext} from 'react';
import AppContext from "../../store";
import ButtonShop, {ButtonShopPropType} from "./ButtonShop";

export const redirect = href => window.open(href, '_blank').focus();

export default function ButtonShopRedirect(props) {
	const {getRedirectLink} = useContext(AppContext);

	const handleOnClick = () => redirect(getRedirectLink());

	return <ButtonShop {...props} onClick={handleOnClick} />
}

ButtonShopRedirect.prototype = ButtonShopPropType;
